module.exports = "/assets/site/images/ROOSTER_logo.jpg?fbabae98846ff5562a40126b4f4526f6";